$(document).ready(function () {
  var $sticky = $("#main-collection-filters");
  var $header = $("sticky-header.header-wrapper.color-background-1.gradient");
  var stickyTop = $sticky.offset().top;
  var isSticky = false;
  
  $sticky.css({
    transition: "all 0.3s ease",
  });

  $(window).on("scroll", function () {
    if ($(window).scrollTop() >= stickyTop && !isSticky) {
      $sticky.css({
        position: "fixed",
        top: "7em",
        maxWidth: "100vw",
        width: "100vw",
        zIndex: 2,
        backgroundColor: "#ffffff",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
      });

      $header[0].style.setProperty("background-color", "#ffffff", "important");
      $header.css({
        transition: "background-color 0.3s ease",
      });

      isSticky = true;
    } else if ($(window).scrollTop() < stickyTop && isSticky) {
      $sticky.css({
        position: "",
        top: "80px",
        width: "",
        zIndex: "",
        backgroundColor: "",
        boxShadow: "",
      });

      $header[0].style.setProperty("background-color", "", "important");

      isSticky = false;
    }
  });

  $(window).on("resize", function () {
    if ($sticky.css("position") === "fixed") {
      $sticky.css("width", "100vw");
    }
  });
});

$(document).ready(function () {
  $(document).on('click', 'button.boost-pfs-filter-button.boost-pfs-filter-clear-all, button.boost-pfs-filter-button.boost-pfs-filter-clear', function() {
    setTimeout(function() {
        var content = `
            <div style="text-align:center; font-family: Arial, sans-serif; font-size:14px; line-height:22px; margin-bottom:15px;">
                <strong>DOWN DENSITY INDICATOR (DDI)</strong>
                <p style="margin-top:10px; margin-bottom:0;">
                    Using only certified Canadian Origin White Duck Down, Nobis jackets offer 
                    optimum fill power to warmth ratio by uniquely working with your body's own heat 
                    to offer the perfect insulating environment against the unpredictable elements.
                </p>
            </div>
        `;
        
        $("#boost-pfs-filter-tree-pf-t-ddi").prepend(content);
        
        $(".boost-pfs-filter-option-item-list li").each(function() {
            var $li = $(this);
            var value = $li.find(".boost-pfs-filter-option-value").text().trim();

            // Map DDI values to images and readable labels
            var ddiMap = {
                "DDI_1": { img: "https://cdn.shopify.com/s/files/1/1037/5246/files/Nobis_Level_1_56932f6c-e081-441b-80da-bc09f725f6ac.png?v=1756763921", label: "Down to -5°C" },
                "DDI_2": { img: "https://cdn.shopify.com/s/files/1/1037/5246/files/Nobis_Level_2_b1d0025a-9246-4e42-a47a-154ac82498fc.png?v=1756763920", label: "Down to -15°C" },
                "DDI_3": { img: "https://cdn.shopify.com/s/files/1/1037/5246/files/Nobis_Level_3_4863dbe0-8769-4fab-b43b-b73d94fe2bf8.png?v=1756763921", label: "Down to -20°C" },
                "DDI_4": { img: "https://cdn.shopify.com/s/files/1/1037/5246/files/Nobis_Level_4_824599bb-023c-4b3b-b86c-dec6cd3bae89.png?v=1756763921", label: "Down to -30°C" },
                "DDI_5": { img: "https://cdn.shopify.com/s/files/1/1037/5246/files/Nobis_Level_5_051d2ed2-eaf3-43f0-8af1-6ceffc4ed634.png?v=1756763921", label: "Down to -40°C" }
            };

            if (ddiMap[value]) {
                var info = ddiMap[value];

                var newContent = `
                    <div class="ddi-item" style="text-align:center; margin:10px auto; display:block;">
                        <img src="${info.img}" alt="${value}" style="max-width:60px; display:block; margin:0 auto 5px;" />
                        <div style="font-size:14px; margin-bottom:5px;">${info.label}</div>
                        ${$li.find(".boost-pfs-check-box")[0].outerHTML}
                    </div>
                `;

                $li.html(newContent);
            }
          });
          $('#boost-pfs-filter-tree-pf-t-ddi button.boost-pfs-filter-button.boost-pfs-filter-apply-button').css({
              'display': 'flex',
              'margin': '2% auto 0'
          });

          var $ul = $('#boost-pfs-filter-tree-pf-t-ddi ul.boost-pfs-filter-option-item-list');
          $ul.attr('id', 'ddi-ul');
          $ul.css({
              'display': 'flex',
              'justify-content': 'space-between',
              'padding-left': '0',
              'list-style': 'none'
          });

          var styles = `
              <style>
                  #boost-pfs-filter-tree-pf-t-ddi {
                      max-width: 700px;
                      width: 70rem;
                  }
                  ul.ddi-ul {
                      display: flex!important;
                      justify-content: space-between;
                      padding-left: 0;
                      list-style: none;
                  }
                  ul.ddi-ul li {
                      flex: 1 1 100px;
                      text-align: center;
                  }
              </style>
          `;
          $("head").append(styles);
          var css = 'div.ddi-item span.boost-pfs-check-box { left: 50% !important; bottom: 0 !important; top: unset!important; }';
          $('<style>').prop('type', 'text/css').html(css).appendTo('head');
          // $('div.ddi-item span.boost-pfs-check-box').css({'bottom': '0', 'left': '50%!important', 'top': 'unset!important'});

    }, 2000);
  });

  setTimeout(function() {
        var content = `
            <div style="text-align:center; font-family: Arial, sans-serif; font-size:14px; line-height:22px; margin-bottom:15px;">
                <strong>DOWN DENSITY INDICATOR (DDI)</strong>
                <p style="margin-top:10px; margin-bottom:0;">
                    Using only certified Canadian Origin White Duck Down, Nobis jackets offer 
                    optimum fill power to warmth ratio by uniquely working with your body's own heat 
                    to offer the perfect insulating environment against the unpredictable elements.
                </p>
            </div>
        `;
        
        $("#boost-pfs-filter-tree-pf-t-ddi").prepend(content);
        
        $(".boost-pfs-filter-option-item-list li").each(function() {
            var $li = $(this);
            var value = $li.find(".boost-pfs-filter-option-value").text().trim();

            // Map DDI values to images and readable labels
            var ddiMap = {
                "DDI_1": { img: "https://cdn.shopify.com/s/files/1/1037/5246/files/Nobis_Level_1_56932f6c-e081-441b-80da-bc09f725f6ac.png?v=1756763921", label: "Down to -5°C" },
                "DDI_2": { img: "https://cdn.shopify.com/s/files/1/1037/5246/files/Nobis_Level_2_b1d0025a-9246-4e42-a47a-154ac82498fc.png?v=1756763920", label: "Down to -15°C" },
                "DDI_3": { img: "https://cdn.shopify.com/s/files/1/1037/5246/files/Nobis_Level_3_4863dbe0-8769-4fab-b43b-b73d94fe2bf8.png?v=1756763921", label: "Down to -20°C" },
                "DDI_4": { img: "https://cdn.shopify.com/s/files/1/1037/5246/files/Nobis_Level_4_824599bb-023c-4b3b-b86c-dec6cd3bae89.png?v=1756763921", label: "Down to -30°C" },
                "DDI_5": { img: "https://cdn.shopify.com/s/files/1/1037/5246/files/Nobis_Level_5_051d2ed2-eaf3-43f0-8af1-6ceffc4ed634.png?v=1756763921", label: "Down to -40°C" }
            };

            if (ddiMap[value]) {
                var info = ddiMap[value];

                var newContent = `
                    <div class="ddi-item" style="text-align:center; margin:10px auto; display:block;">
                        <img src="${info.img}" alt="${value}" style="max-width:60px; display:block; margin:0 auto 5px;" />
                        <div style="font-size:14px; margin-bottom:5px;">${info.label}</div>
                        ${$li.find(".boost-pfs-check-box")[0].outerHTML}
                    </div>
                `;

                $li.html(newContent);
            }
          });
          $('#boost-pfs-filter-tree-pf-t-ddi button.boost-pfs-filter-button.boost-pfs-filter-apply-button').css({
              'display': 'flex',
              'margin': '2% auto 0'
          });

          var $ul = $('#boost-pfs-filter-tree-pf-t-ddi ul.boost-pfs-filter-option-item-list');
          $ul.attr('id', 'ddi-ul');
          $ul.css({
              'display': 'flex',
              'justify-content': 'space-between',
              'padding-left': '0',
              'list-style': 'none'
          });

          var styles = `
              <style>
                  #boost-pfs-filter-tree-pf-t-ddi {
                      max-width: 700px;
                      width: 70rem;
                  }
                  ul.ddi-ul {
                      display: flex!important;
                      justify-content: space-between;
                      padding-left: 0;
                      list-style: none;
                  }
                  ul.ddi-ul li {
                      flex: 1 1 100px;
                      text-align: center;
                  }
              </style>
          `;
          $("head").append(styles);
          var css = 'div.ddi-item span.boost-pfs-check-box { left: 50% !important; bottom: 0 !important; top: unset!important; }';
          $('<style>').prop('type', 'text/css').html(css).appendTo('head');
          // $('div.ddi-item span.boost-pfs-check-box').css({'bottom': '0', 'left': '50%!important', 'top': 'unset!important'});

    }, 2000);

  var currentURL = window.location.href;
  if ( currentURL.includes("collections") || currentURL.includes("ss25-women") || currentURL.includes("ss25-men") || currentURL.includes("ss24-women") || currentURL.includes("ss24-men") || currentURL.includes("ss24-launch") || currentURL.includes("mens-parkas") || currentURL.includes("womens-parkas") ) {
    console.log("url contains!!!!!");
    var $bannerWide = $(
      "li.grid__item.banner.banner-wide"
    ).detach();
    var $bannerSmall = $(
      "li.grid__item.banner.banner-small"
    ).detach();

    var $gridItems = $(
      "li.grid__item.grid-ratio-full.banner.main-banner.half-width, li.grid__item.grid-ratio-full, li.grid__item.variant.grid-ratio-full, li.grid__item.grid-ratio-portrait, li.grid__item.variant.grid-ratio-portrait, li.grid__item.variant.grid-ratio-adapt, li.grid__item.grid-ratio-adapt"
    );
    console.log($bannerWide, $bannerSmall, "test!!!!", $gridItems)
    var itemsBeforeBannerWide = 8;
    var itemsBeforeBannerSmall = 12;

    $gridItems.each(function (index) {
      if (index === itemsBeforeBannerWide) {
        $(this).after($bannerWide);
      }
      if (index === itemsBeforeBannerSmall) {
        $(this).after($bannerSmall);
      }
    });
  } else {
    console.log("URL does not contain ss24-women");
  }
});
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector("form").addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this)
    );

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define("facet-remove", FacetRemove);
